import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { FC } from "react";
import UserAdminFilter from "src/containers/UserAdminFilter/UserAdminFilter";

interface Props {
	data: any;
}

const JsonDebug: FC<Props> = ({ data }) => {
	return null;

	const [isOpen, setIsOpen] = useState(false);

	return (
		<UserAdminFilter>
			<button
				type="button"
				onClick={() => setIsOpen((prev) => !prev)}
				className="flex items-center border px-4 gap-2 my-4"
			>
				{isOpen ? "Close" : "Open"} JsonDebug{" "}
				{isOpen ? <ChevronUp /> : <ChevronDown />}
			</button>
			{isOpen && (
				<pre>
					<code>{JSON.stringify(data, null, 2)}</code>
				</pre>
			)}
		</UserAdminFilter>
	);
};

export default JsonDebug;
